(ns app.front.view.licence.util
  (:require [app.domain.licence.generic-model :as gl-model]
            [core.front.date-util :as date-util]))

(defn licence-expires-soon? [licence-like]
  (let [valid-to (gl-model/get-valid-to licence-like)]
    (and valid-to
         (date-util/before? valid-to
                            (date-util/goog-add-months (date-util/now) 1)))))

(defn valid? [{:domain/keys [state]}]
  (= state :licence.state/active))
